import { Component } from '@angular/core';

@Component({
  selector: 'app-word-pdf-content',
  imports: [],
  templateUrl: './word-pdf-content.component.html',
  styleUrl: './word-pdf-content.component.css'
})
export class WordPdfContentComponent {

}
